import type { AnswerPart } from '@d-orca/shared/ai-answer';

/**
 * A React key for part `n` of an answer, derived from what the part IS rather
 * than where it sits: a drawing by its kind and its index in the message's
 * list, a stretch of prose by how many stretches precede it. While an answer
 * streams, a marker arriving ahead of its drawing shifts every part after it —
 * keyed by position, that remounts the table (its animation replays, its sort
 * and search reset).
 *
 * Shared by the full page and the dashboard card so the two cannot drift.
 */
export function answerPartKey<D extends { kind: string }>(parts: readonly AnswerPart<D>[], n: number): string {
  const part = parts[n]!;
  if (part.kind === 'drawing') return `${part.drawing.kind}-${part.at}`;
  // The first stretch keeps the key a one-paragraph answer had.
  const stretch = parts.slice(0, n).filter((p) => p.kind === 'text').length;
  return stretch === 0 ? 'text' : `text-${stretch}`;
}
